import { Popover } from "antd";
import styled from "styled-components";

export const FilterDropdownContainer = styled.div`
  .filter-container {
    min-width: 300px;
    max-width: 300px;
    max-height: 150px;
    min-height: 150px;
    border-radius: 8px;
    /* overflow-y: scroll; */
    padding: 10px 0 0 0;
  }

  .title {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: var(--text-primary);
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--border-color) !important;
    border-radius: 6px !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    //   background: rgba(0, 0, 0, 0.6) !important;
    cursor: pointer !important;
  }
`;

export const FilterTagContiner = styled.div`
  .tag {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 4px;
    padding: 0px 12px;
    letter-spacing: 1.3px;
    border-radius: 4px;
    font-style: none;
    /* font-weight: 400; */
    font-size: 12px;
    line-height: 20px;
    cursor: pointer;
  }
`;

export const FilterDiv = styled(Popover)`
  .ant-popover-placement-bottomLeft .ant-popover-arrow {
    left: 6px;
  }
  .ant-popover-inner-content {
    width: -moz-max-content;
    width: max-content;
    max-width: 100%;
    padding: 0px !important;
    color: rgba(0, 0, 0, 0.85);
    background-color: red;
  }

  .ant-popover {
    top: 200px !important;
    left: 300px !important;
  }
`;

export const FilterSearchBox = styled.div`
  .ant-input {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    -webkit-font-feature-settings: "tnum", "tnum", "tnum";
    font-feature-settings: "tnum", "tnum", "tnum";
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    color: var(--text-primary);
    font-size: 12px !important;
    line-height: 1.5715;
    background-color: var(--primary-bg);
    background-image: none;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    transition: all 0.3s;
    height: 35px !important;
  }

  .ant-input::placeholder {
    color: var(--text-secondary);
  }
`;

export const FilterWrapper = styled.div`
  .ant-popover-inner {
    background-color: var(--primary-bg);
    border: 1px solid var(--border-color);
    border-radius: 6px;
  }
`;
